import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '@core/broadcaster/broadcaster.service';

@Injectable()
export class CannotGetAuthTokenEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(token: any): void {
    this.broadcaster.broadcast(CannotGetAuthTokenEvent, {
      token: token
    });
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(CannotGetAuthTokenEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/events/CannotGetAuthTokenEvent.ts